<div class="flex gap-x-5 items-center">
  <svg-icon [src]="icon"></svg-icon>
  <div class="flex flex-col">
    <span class="font-main font-bold text-xl text-navy-80 text-left mb-1">{{ title }}</span>
    <span class="font-main text-sm text-navy-70">
      {{ comingSoon ? (buildTranslationKey('comingSoon') | translate) : description }}
    </span>
  </div>
</div>

@if (comingSoon) {
  <svg-icon [src]="'coming-soon'"></svg-icon>
}
